import { FEATURE_LOYALTY_UI_SINGLETON } from 'features/content/hooks/use-feature-loyalty-ui';

import { useFeatureLoyaltyShortCodePaymentErrorModalQuery } from 'generated/sanity-graphql';

export const useShortCodePaymentErrorModal = () => {
  const { data, loading } = useFeatureLoyaltyShortCodePaymentErrorModalQuery({
    variables: { featureLoyaltyUIId: FEATURE_LOYALTY_UI_SINGLETON },
  });

  return { data: data?.LoyaltyUI, loading };
};
